export interface SiteAsset {
  id: string;
  type: string;
  name: string;
  position: number;
  source: string;
  sub_type: string;
}
